import { useQuery } from '@tanstack/react-query';
import { publicQueries } from '@blimo/api-client';
import { useApi } from '@blimo/api-client/react';
import { BrandingProvider } from '@blimo/ui';

/** Browser tab title: "<Kurzname> Verwaltung". @param {{ short_name?: string }} b */
const title = (b) => `${b.short_name || 'BLIMO'} Verwaltung`;

/**
 * Loads GET /branding once (long staleTime, also before login) and provides it to BrandLogo, auth layouts and pages.
 * The bundled BLIMO defaults render first; colours come from the localStorage cache applied in index.html.
 * @param {{ children: import('react').ReactNode }} props
 */
export function AppBranding({ children }) {
  const api = useApi();
  const { data } = useQuery({ ...publicQueries.branding(api), enabled: typeof api.public?.branding === 'function' });
  return (
    <BrandingProvider branding={data ?? null} title={title}>
      {children}
    </BrandingProvider>
  );
}
